// File contains a collection of methods that get shared between Product
// related components
import { NumberFormatter } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import { omit } from 'lodash';
import { constants } from '@wsb/guac-widget-core';

const getType = (currency, percentage) => {
  if (currency) {
    return 'Currency';
  } else if (percentage) {
    return 'Percentage';
  }
  return 'Number';
};

export const formatPrice = ({ currency, precision, number, percentage }) => {
  const precisionMatters = currency || Number(precision) !== 0;

  const methodName = `toFormatted${getType(currency, percentage)}`;
  return NumberFormatter[methodName](number, precisionMatters, precisionMatters);
};

export const priceIsObject = price => {
  return price !== null && typeof price === 'object';
};

const hasSalePriceOld = product => {
  return (
    product['on_sale?'] && product.sale_price !== null && typeof product.sale_price !== 'undefined'
  );
};

export const hasSalePrice = product => {
  if (!priceIsObject(product.sale_price)) {
    return hasSalePriceOld(product);
  }

  return (
    product['on_sale?'] &&
    product.sale_price.numeric !== null &&
    typeof product.sale_price.numeric !== 'undefined'
  );
};

const percentDifference = (normal, discount) => {
  let percentage = Math.round(100 * (1 - discount / normal));
  if (percentage === 100 && parseFloat(discount) !== 0) percentage = 99;

  return percentage;
};

const calculateSalePercentageForPriceObjects = (price, salePrice) => {
  if (price.numeric === null || salePrice.numeric === null) return 0;
  if (price.numeric - salePrice.numeric === 0) return 0;

  return percentDifference(price.numeric, salePrice.numeric);
};

export const calculateSalePercentage = (price, salePrice) => {
  if (price === null || salePrice === null) return 0;
  if (priceIsObject(price)) {
    return calculateSalePercentageForPriceObjects(price, salePrice);
  }
  if (price - salePrice === 0) return 0;

  return percentDifference(price, salePrice);
};

export const modifyLinkPropsForMode = (linkProps, renderMode, shopWidgetSamePage) => {
  const { renderModes } = constants;

  if (linkProps && linkProps.href) {
    // Remove any potential double // in the relative url path
    linkProps.href = linkProps.href.replace(/\/\//g, '/');
  }

  if (renderMode === renderModes.EDIT) return omit(linkProps, ['onClick']);
  if (!shopWidgetSamePage) return omit(linkProps, ['onClick']);
  if (renderMode !== renderModes.PUBLISH) return omit(linkProps, ['data-page', 'data-page-query']);

  return linkProps;
};
